export const apiConfig = {
  // local: 'http://localhost:4300',
  local: 'https://api-kube.sb.evoent.tech/',
  stage: 'https://api-kube.sb.evoent.tech/',
  prod: 'https://api-kube.evoplay.games/',
};
